const Forms = [
  {
    type: "multipleSelect",
    options: "CatStatus",
    label: "status",
    class: "col-md-4 col-lg-3 col-sm-12",
    name: "Status",
    id: "Status",
    id2: "Status",
    datatype: "select",
    show: true,
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatConsignor",
    label: "receive_consignor",
    class: "col-md-4 col-lg-3 col-sm-12",
    name: "Consignor",
    id2: "Consignor",
    id: "Consignor",
    datatype: "select",
    show: true,
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatConsignee",
    label: "receive_consignee",
    id2: "Consignee",
    class: "col-md-4 col-lg-3 col-sm-12",
    name: "Consignee",
    id: "Consignee",
    datatype: "select",
    show: true,
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatDestination",
    label: "receive_destination",
    id2: "Destination",
    class: "col-md-4 col-lg-3 col-sm-12",
    name: "Destination",
    id: "Destination",
    datatype: "select",
    show: true,
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatTransport",
    label: "receive_transport",
    id2: "Transport",
    class: "col-md-4 col-lg-3 col-sm-12",
    name: "Transport",
    id: "Transport",
    datatype: "select",
    show: true,
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    values: [],
  },

  {
    type: "Datetime",
    label: "dispatch",
    name: "DispatchList",
    class: "col-md-12 col-lg-3 col-sm-12",
    id: "DispatchList",
    id2: "DispatchList",
    style: { fontSize: "11px", fontWeight: "bold" },
    value: "",
    format: "YYYY-MM-DD",
    values: [],
  },
];

export default Forms;
